export default __webpack_public_path__ + "static/media/btn-logo.292e5c94.jpg";